export default {
  account_id_required: "จำเป็นต้องมี ID บัญชี",
  account_not_exists: "รหัสผ่านไม่ถูกต้อง.",
  accountIdRequired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  agent_comm_rate_required: "ต้องมีอัตราค่าคอมมิชชั่นตัวแทน",
  agent_id_required: "ต้องมีรหัสตัวแทน",
  alphaNumOnly: "ตัวอักษรและตัวเลขเท่านั้น",
  atLeastThreeMatchToBetParlay: "อย่างน้อยผสมสามนัดเพื่อเดิมพันในพาร์เลย์",
  atLeastTwoMatchToBetParlay: "อย่างน้อยผสมการแข่งขันสองนัดเพื่อเดิมพันในพาร์เลย์",
  bet_amount_required: "ต้องมีจำนวนเงินเดิมพัน",
  bet_id_required: "ต้องมี ID เดิมพัน",
  betAmountRequired: "จำนวนเงินเดิมพันจำเป็น",
  betExists: "มีการเดิมพันอยู่แล้ว",
  betLowerMin: "เงินเดิมพันของคุณน้อยกว่าเงินเดิมพันขั้นต่ำ",
  betNotExists: "กรุณาวางเดิมพันที่ถูกต้องเพื่อเข้าร่วมการแข่งขัน.",
  betOverMax: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  betOverMaxBet: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  betOverMaxPerMatch: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด.",
  betTypeRequired: "ประเภทการเดิมพันจำเป็น",
  BLOCK: "บัญชีถูกบล็อก!",
  changeStakeMax: "จำนวนเงินเดิมพันเข้ามีการเปลี่ยนแปลงเนื่องจากขีดจำกัด MAX",
  changeStakeMin: "จำนวนเงินเดิมพันเข้ามีการเปลี่ยนแปลงเนื่องจากขีดจำกัดขั้นต่ำ",
  CLOSE: "บัญชีถูกปิด!",
  close: "บัญชีถูกปิด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  confirmNewPasswordRequired: "ยืนยันว่าต้องการรหัสผ่านใหม่!",
  connectionFailed: "ไม่สามารถเชื่อมไปยังระบบกระเป๋าเงินได้",
  containAlphaNum: "{fname} ต้องมีตัวอักษรอย่างน้อยหนึ่งตัวและหนึ่งหมายเลข",
  "createRoomFailed-1": "สร้างห้องล้มเหลว 1",
  "createRoomFailed-2": "สร้างห้องล้มเหลว 2",
  "createRoomFailed-3": "สร้างห้องล้มเหลว 3",
  credit_amount_required: "จำเป็นต้องมีจำนวนเครดิต",
  currency_required: "ต้องใช้สกุลเงิน",
  currencyNotSupported: "ไม่รองรับสกุลเงิน",
  currPasswordRequired: "ต้องใช้รหัสผ่านปัจจุบัน!",
  dataError: "ข้อมูลผิดพลาด",
  debit_amount_required: "ต้องระบุจำนวนเดบิต",
  duplicate_credit_record: "บันทึกเครดิตซ้ำ",
  duplicate_debit_record: "อัตราเดิมพันกำลังอัปเดต...",
  endDateRequired: "ต้องระบุวันที่สิ้นสุด!",
  EsportsDisabled: "เกม E-Sports ปิดการใช้งาน",
  forbiddenAccess: "ไม่ได้รับอนุญาตการเข้าถึง",
  FREEZE: "บัญชีถูกอายัด",
  freeze: "บัญชีถูกอายัด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  game_maintenance: "เกมกำลังปิดปรับปรุง",
  incompletedRequest: "เกิดข้อผิดพลาดบางอย่าง ...",
  insufficient_balance: "เครดิตไม่เพียงพอ",
  invalid_password: "รหัสผ่านไม่ถูกต้อง.",
  invalidBetAmount: "จำนวนเงินเดิมพันไม่ถูกต้อง",
  invalidBets: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  invalidCurrency: "สกุลเงินที่จะเดิมพันไม่ถูกต้อง",
  invalidleague: "ลีกไม่ถูกต้อง",
  invalidMarketType: "ระบุประเภทตลาดไม่ถูกต้อง",
  invalidMatch: "การจับคู่ไม่ถูกต้อง",
  invalidMember: "สมาชิกไม่ถูกต้อง",
  invalidOddsBall: "อัตราเดินพันกำลังอัปเดต ...",
  invalidOperator: "ตัวดำเนินการไม่ถูกต้อง",
  invalidPassword: "รหัสผ่านไม่ถูกต้อง",
  invalidRoom: "ห้องไม่ถูกต้อง",
  invalidRoomLimit: "การจำกัดห้องไม่ถูกต้อง",
  invalidRoomPassword: "รหัส PIN ไม่ถูกต้อง รหัส PIN ต้องเป็นตัวเลข 6 หลัก",
  invalidRoomRate: "ราคาห้องพักไม่ถูกต้อง",
  invalidRoomType: "ประเภทห้องไม่ถูกต้อง",
  invalidRTSMatchOdds: "อัตราต่อรอง RTS Match ไม่ถูกต้อง",
  invalidSession: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  IPJoinedBefore: "IP เข้าร่วมก่อน",
  isAlpha: "{fname} ยอมรับเฉพาะตัวอักษรเท่านั้น.",
  isAlphaNum: "{fname} ยอมรับเฉพาะตัวอักษรและตัวเลข.",
  isEmail: "{fname} ยอมรับที่อยู่อีเมลที่ถูกต้องเท่านั้น.",
  isIpAddress: "{fname} ยอมรับเฉพาะที่อยู่ IPv4 ที่ถูกต้อง",
  isMaxLength: "{fname} ต้องน้อยกว่าหรือเท่ากับอักขระ {fvalue} ตัว.",
  isMaxValue: "{fname} ต้องน้อยกว่าหรือเท่ากับ {fvalue}.",
  isMinLength: "{fname} ต้องมีอักขระอย่างน้อย {fvalue} ตัว.",
  isMinValue: "{fname} ต้องมีอย่างน้อย {fvalue}.",
  isNumeric: "{fname} ยอมรับเฉพาะตัวเลข.",
  isOutrightRequired: "จำเป็นต้องขอข้อมูล",
  // vuelidate
  isRequired: "โปรดป้อน {fname}.",
  isSameAs: "{fname} ต้องเหมือนกับ {fname2}.",
  isUrl: "{fname} ยอมรับ URL เท่านั้น",
  "joinFailed-1": "เข้าร่วมห้องล้มเหลว 1",
  "joinFailed-2": "เข้าร่วมห้องล้มเหลว 2",
  leagueIdRequired: "ต้องระบุลีก ID!",
  liveCasinoDisabled: "ปิดการใช้งานคาสิโนสด",
  liveMatchNotAllowed: "ไม่อนุญาตให้มีการแข่งขันสด",
  //tournament
  login_id_not_exists: "การเข้าสู่ระบบไม่ถูกต้อง โปรดลองเข้าสู่ระบบอีกครั้ง",
  loginFailed: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  loginLimit: "คุณเข้าสู่ระบบบ่อยเกินไปโปรดลองอีกครั้งหลังจาก 1 นาที ...",
  lotteryDisabled: "ปิดการใช้งานลอตเตอรี่",
  marketTypeChanged: "ใบเดิมพัน ถูกลบออกเนื่องจากมีการเปลี่ยนแปลงประเภทตลาด <br/> โปรดเลือกใหม่จากตลาดอีกครั้ง.",
  marketTypeRequired: "ต้องระบุประเภทตลาด",
  master_comm_rate_required: "ต้องมีอัตราค่าคอมมิชชั่นหลัก",
  master_id_required: "ต้องมี Master ID",
  matchDateRequired: "ต้องมีวันที่ตรงกัน",
  matchHide: "แมตช์นี้ไม่พร้อมใช้งาน โปรดลองแมตช์อื่น",
  matchLowerMin: "เกิดข้อผิดพลาดในการจับคู่ค่าต่ำสุด",
  matchNotActive: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  matchNotAllowBet: "แมตช์นี้ไม่พร้อมใช้งาน โปรดลองแมตช์ในตลาดอื่น",
  matchOverMax: "เกิดข้อผิดพลาด Match over max",
  matchRequired: "ต้องมีการจับคู่",
  maxMatch: "เลือกได้สูงสุด {max} รายการ",
  maxParlayTicket: "เข้าถึงตั๋วสูงสุดต่อพาร์เลย์!",
  maxRoomLimit: "จำนวนผู้เล่นต้องเท่ากับหรือน้อยกว่า 30",
  maxRoomRate: "ค่าธรรมเนียมแรกเข้าต้องเท่ากับหรือน้อยกว่า 1,000",
  member_id_required: "ต้องมีรหัสสมาชิก",
  member_wallet_not_exists: "ไม่มีกระเป๋าเงินสมาชิก",
  memberExists: "สมาชิกมีอยู่แล้ว",
  memberJoinedBefore: "คุณเคยเข้าร่วมมาก่อน โปรดทราบว่าห้องสาธารณะฟรีสามารถเข้าร่วมได้เพียงครั้งเดียว",
  minBetAmount: "เกิดข้อผิดพลาดจำนวนเงินเดิมพันขั้นต่ำ",
  MiniGameDisabled: "ปิดการใช้งานมินิเกม",
  minMatch: "เลือกการแข่งขันขั้นต่ำ 3 รายการ",
  minRoomLimit: "จำนวนผู้เล่นต้องเท่ากันหรือมากกว่า 3",
  minRoomRate: "ค่าธรรมเนียมแรกเข้าต้องเท่ากับหรือมากกว่า 10",
  new_login_id_exists: "ชื่อเล่นไม่ถูกต้องโปรดลองตั้งชื่อเล่นอื่น",
  newPasswordRequired: "ต้องการรหัสผ่านใหม่!",
  nickNameRequired: "ต้องมีชื่อเล่น!",
  noMatchSelected: "โปรดเลือกอย่างน้อย 1 รายการ",
  notSameAs: "{fname} และ {fname2} ต้องไม่เหมือนกัน",
  NoUserAccessRight: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  oddsDisplayInvalid: "อัตราเดิมพันกำลังอัปเดต...",
  oddsIsUpdating: "อัตราเดิมพันกำลังอัปเดต...",
  OK: "ตกลง",
  pageNumberRequired: "ต้องระบุหมายเลขหน้าเพจ!",
  pageSizeRequired: "ต้องระบุขนาดหน้าเพจ!",
  passwordRequired: "ต้องการรหัสผ่าน!",
  passwordsNotMatch: "รหัสผ่านไม่ตรงกัน!",
  permission_denied: "การอนุญาตถูกปฏิเสธ",
  pointsOverLimit: "เกิดข้อผิดพลาดของ point over limit",
  rate_required: "จำเป็นต้องระบุราคา",
  rateLowerMin: "เกิดข้อผิดพลาดขั้นต่ำของอัตราที่ต่ำกว่า",
  rateOverMax: "เกิดข้อผิดพลาดอัตราเกินสูงสุด",
  requestFailed: "การเชื่อมต่อของคุณไม่เสถียร โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
  requestLimit: "คุณมีคำขอบ่อยเกินไป",
  requestPending: "รอการร้องขอ …",
  result_exists: "ผลลัพธ์มีอยู่แล้ว",
  room_id_required: "ต้องมีรหัสห้อง",
  roomClosed: "ห้องปิด",
  roomClosedNotAllowed: "ไม่อนุญาตให้ปิดห้อง",
  roomEnded: "ห้องสิ้นสุดแล้ว",
  roomEndedOrCancelled: "ห้องสิ้นสุดหรือถูกยกเลิก",
  roomExists: "ไม่อนุญาตให้สร้างห้องส่วนตัวมากกว่า 1 ห้อง",
  RoomExists: "ไม่อนุญาตให้สร้างห้องส่วนตัวมากกว่า 1 ห้อง",
  roomFull: "ห้องเต็มแล้ว",
  roomIdRequired: "ต้องมีรหัสห้อง",
  roomIsPublicFree: "ห้องสาธารณะฟรี",
  roomLimitLowerMin: "เกิดข้อผิดพลาดต่ำสุดของขีดจำกัดห้อง",
  roomLimitOverMax: "เกิดข้อผิดพลาดเกินขีดจำกัดของห้อง",
  roomLimitRequired: "ต้องจำกัดจำนวนห้อง",
  roomNotExists: "ไม่มีห้องอยู่",
  roomOverMax: "เกิดข้อผิดพลาด Room Over Max",
  roomPasswordRequired: "ต้องใช้รหัส PIN",
  roomRateRequired: "ต้องระบุราคาห้องพัก",
  roomTypeRequired: "จำเป็นต้องระบุประเภทห้อง",
  s_senior_comm_rate_required: "จำเป็นต้องมีอัตราค่าคอมมิชชั่น Super Senior",
  s_senior_id_required: "จำเป็นต้องมี Super Senior ID",
  secondary_account_exists: "ชื่อเล่นของคุณถูกสร้างไว้แล้ว",
  selectLeague: "โปรดเลือกอย่างน้อย 1 ลีก",
  selectOption: "กรุณาเลือก {fname}",
  senior_comm_rate_required: "ต้องมีอัตราค่าคอมมิชชั่นอาวุโส",
  senior_id_required: "ต้องมี ID อาวุโส",
  session_expired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  session_not_exists: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  sessionTokenRequired: "จำเป็นต้องมีโทเค็นเซสชั่น",
  shareholder_comm_rate_required: "ต้องระบุอัตราค่าคอมมิชชั่นสำหรับผู้ถือหุ้น",
  shareholder_id_required: "ต้องมีรหัสผู้ถือหุ้น",
  slotDisabled: "ปิดการใช้งานสล็อต",
  sportsTypeRequired: "ต้องมีประเภทกีฬา!",
  startDateRequired: "ต้องระบุวันที่เริ่ม!",
  SUSPEND: "บัญชีของคุณเปลี่ยนเป็นดูได้เท่านั้น",
  suspend: "บัญชีถูกระงับ! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  systemError: "ข้อผิดพลาดระบบภายใน",
  tournamentDisabled: "การแข่งขันถูกปิดใช้งาน โปรดตรวจสอบติดต่ออัพไลน์ของคุณ",
  tournamentLeagueExists: "มีลีกทัวร์นาเมนต์อยู่",
  tournamentMatchExists: "มีการแข่งขันทัวร์นาเมนต์",
  transfer_id_required: "ต้องมี ID การโอน",
  unableToGetBalanceAtTheMoment: "ข้อผิดพลาดเซิร์ฟเวอร์ภายใน",
  usernameRequired: "ต้องมีชื่อผู้ใช้!",
  workingDateRequired: "ต้องระบุวันทำงาน!",
  matchNotStarted: "การแข่งขันยังไม่เริ่มต้น",
  cashOutUnavailable: "การถอนเงินไม่พร้อมใช้งาน",
  errorCashoutAmount: "การถอนเงินกำลังอัปเดต...",
  invalidParameter: "พารามิเตอร์ไม่ถูกต้อง",
  startTimeRequired: "ต้องระบุวันที่เริ่ม!",
  endTimeRequired: "ต้องระบุวันที่สิ้นสุด!",
  oddsTypeIDRequired: "ต้องระบุประเภทอัตราเดิมพัน!",
  commissionRequired: "ต้องระบุค่าคอมมิชชั่น!",
  requestTimeRequired: "ต้องระบุวันที่ร้องขอ!",
  statusRequired: "ต้องระบุสถานะ!",
  invalidStartTime: "วันที่เริ่มไม่ถูกต้อง!",
  invalidEndTime: "วันที่สิ้นสุดไม่ถูกต้อง!",
  invalidOddsTypeID: "ประเภทอัตราเดิมพันไม่ถูกต้อง!",
  invalidCommission: "ค่าคอมมิชชั่นไม่ถูกต้อง!",
  invalidRequestTime: "วันที่ร้องขอไม่ถูกต้อง!",
  invalidStatus: "สถานะไม่ถูกต้อง!",
  invalidAlgoMatchInfo: "ตลาดนี้ปิดการใช้งาน โปรดลองตลาดอื่น!",
  invalidAlgoSliderLeagueInfo: "ข้อมูลลีกไม่ถูกต้อง!",
  invalidAlgoSliderMinutesWeight: "น้ำหนักนาทีไม่ถูกต้อง!",
  invalidAlgoSliderBetType: "ประเภทการเดิมพันไม่ถูกต้อง!",
  invalidRTSRunningScoreDetails: "ข้อมูลคะแนนสำหรับ RTS ไม่ถูกต้อง!",
  invalidProviderGoalTimeLine: "ข้อมูลเส้นเวลาปลายทางไม่ถูกต้อง!",
  invalidSliderTimeRange: "ช่วงเวลาการสลิปไม่ถูกต้อง!",
  invalidMOMatchOdds: "อัตราเดิมพันการแข่งขันกำลังอัปเดต...",
  invalidProviderSlider: "ข้อมูลผู้ให้บริการสลิปไม่ถูกต้อง!",
  invalidCombineBetTypeAndOddsFormat: "รูปแบบการเดิมพันและอัตราเดิมพันไม่ถูกต้อง!",
  invalidMatchInformation: "ข้อมูลการแข่งขันไม่ถูกต้อง!",
  marketClose: "ตลาดนี้ปิดแล้ว โปรดลองตลาดอื่น",
  error: "ข้อผิดพลาด",
  freeRoomNeedBet: "กรุณาวางเดิมพันที่ถูกต้องเพื่อเข้าร่วมการแข่งขัน.",
};
